import React from 'react';
import { gridBorder } from './styles';
import { border } from '../styles';

const SpanHeaderCell = ({
    headerName,
    colSpan,
    width,
    style,
    scrollPxH,
    scrollPxV,
    isColSticky
}) => {
    return (
        <th
            colSpan={colSpan}
            width={width}
            style={{
                ...gridBorder,
                backgroundColor: '#FFFFFF',
                position: 'relative',
                boxSizing: 'border-box',
                border: border,
                bottom: scrollPxV,
                zIndex: 200,
                right: isColSticky ? undefined : scrollPxH,
                ...style
            }}
        >
            <div>
                <span>{headerName}</span>
            </div>
        </th>
    );
};

export default SpanHeaderCell;
